<template>
  <div class="Daily_New_account">
    <el-form style="padding-top: 20px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >

      <el-form-item  style="width: 340px;" label="学生学号">
        <el-select style="width: 340px;" filterable v-model="ruleForm.userId" placeholder="请输入学生学号查询并选择学生信息" @change="xs()" prop="userId">
          <el-option v-for="item in userIdlist" :key="item.userId"  :label=" '姓名：'+item.realName+ '  部门：' + item.deptName + '  学号：' + item.userId"  :value="item.userId">
            <div>
              <p>姓名：{{item.realName}} &nbsp;&nbsp;&nbsp;&nbsp; 学号：{{item.userId}}</p>
              <p>培养部门：{{item.deptName}}</p>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学生姓名" prop="realName">
        <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
      </el-form-item>

      <el-form-item label="培养部门">
        <div class="block">
          <el-input v-model="ruleForm.deptId" :disabled="true">
          </el-input>
        </div>
      </el-form-item>

      <el-form-item label="管理部门">
        <div class="block">
          <el-input v-model="ruleForm.trainName" :disabled="true">
          </el-input>
        </div>
      </el-form-item>

      <el-form-item label="预警者姓名"  prop="alertName">
        <el-input v-model="ruleForm.alertName"  placeholder="请输入预警人"></el-input>
      </el-form-item>

      <el-form-item label="预警人手机" prop="alertPhone">
        <el-input v-model="ruleForm.alertPhone" placeholder="请输入预警人电话" maxlength="11" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="学生疑似异常情况" class="jojsss" prop="difficultDetail">
        <el-input type="textarea" v-model="ruleForm.difficultDetail" placeholder="请输入学生疑似异常情况" maxlength="500" show-word-limit></el-input>
      </el-form-item>

      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        "五困"类型及具体表现
      </h2>

      <el-form-item class="difficulty" label="学习困扰">
        <el-checkbox-group :max="3" style="position: relative" v-model="ruleForm.studyDifficulty">
          <el-checkbox label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>

        <span style=" width: 200px; position: absolute; top: 0px; right: 30px; display: block; color: #606266;">其他</span>

        <el-input style="width: 200px; position: absolute; top: 2px; right: -10px" v-model="ruleForm.studyDifficultyOther" placeholder="请输入学习困扰" maxlength="30" show-word-limit></el-input>

      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰">
        <el-checkbox-group :max="3" style="position: relative" v-model="ruleForm.lifeDifficulty">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right: 0px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px; position: absolute; top: 2px; right: -40px" v-model="ruleForm.lifeDifficultyOther" placeholder="请输入生活困难" maxlength="30" show-word-limit></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="交往困扰">
        <el-checkbox-group :max="3" style="position: relative" v-model="ruleForm.contactDifficulty">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>

        <span style="width: 200px;position: absolute;top: 0px;right: 0px;display: block;color: #606266;">其他</span>
        <el-input v-model="ruleForm.contactDifficultyOther" style="width: 200px; position: absolute; top: 2px; right: -40px" placeholder="请输入交往困难" maxlength="30" show-word-limit></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="发展困扰">
        <el-checkbox-group :max="3" style="position: relative" v-model="ruleForm.developDifficulty">
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right: 130px;display: block;color: #606266;">其他</span>
        <el-input v-model="ruleForm.developDifficultyOther" style="width: 200px;position: absolute;top:2px;right:90px"  placeholder="请输入发展困难" maxlength="30" show-word-limit></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰">
        <el-checkbox-group :max="3" style="position: relative" v-model="ruleForm.psyDifficulty">
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>

        
        <span style="width: 200px;position: absolute;top: 0px;right: 80px;display: block;color: #606266;">其他</span>
        <el-input v-model="ruleForm.psyDifficultyOther" style="width: 200px; position: absolute; top: 2px; right: 40px" placeholder="请输入心理困难" maxlength="30" show-word-limit
        ></el-input>
      </el-form-item>

      <h2 style="font-size:20px;margin-left:20px;padding-bottom:20px">
        发现途径
      </h2>

      <el-form-item class="quz">
        <el-checkbox-group :max="3" v-model="ruleForm.discovery">
          <el-checkbox label="1"  name="type">学生本人</el-checkbox>
          <el-checkbox label="2"  name="type">家人配偶</el-checkbox>
          <el-checkbox label="3"  name="type">其他亲属</el-checkbox>
          <el-checkbox label="4"  name="type">同学</el-checkbox>
          <el-checkbox label="5"  name="type">朋友</el-checkbox>
          <el-checkbox label="6"  name="type">心理委员</el-checkbox>
          <el-checkbox label="7"  name="type">心理联络员</el-checkbox>
          <el-checkbox label="8"  name="type">心理辅导员</el-checkbox>
          <el-checkbox label="9"  name="type">辅导员</el-checkbox>
          <el-checkbox label="10" name="type">班主任</el-checkbox>
          <el-checkbox label="11" name="type">心理中心</el-checkbox>
          <el-checkbox label="12" name="type">授课教师</el-checkbox>
          <el-checkbox label="13" name="type">导师</el-checkbox>
          <el-checkbox label="14" name="type">其他校内人员</el-checkbox>
          <el-checkbox label="15" name="type">其他校外人员</el-checkbox>
          <el-checkbox label="16" name="type">微信微博QQ</el-checkbox>
          <el-checkbox label="17" name="type">电话短信邮件</el-checkbox>
          <el-checkbox label="18" name="type">书面</el-checkbox>
          <el-checkbox label="19" name="type">当面交流</el-checkbox>
          <el-checkbox label="20" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px">
        问题备注及应对工作（<i style="color: red">*</i>为必填项）
      </h2>

      <el-form-item class="cpwjzt" label="初评危机状态">
        <el-radio v-model="ruleForm.firstCrisis" label="1">红色预警</el-radio>
        <el-radio v-model="ruleForm.firstCrisis" label="2">橙色预警</el-radio>
        <el-radio v-model="ruleForm.firstCrisis" label="3">黄色预警</el-radio>
        <el-radio v-model="ruleForm.firstCrisis" label="4">蓝色预警</el-radio>
        <el-radio v-model="ruleForm.firstCrisis" label="5">绿色预警</el-radio>
        <el-radio v-model="ruleForm.firstCrisis" label="6">无法确定</el-radio>
      </el-form-item>

      <el-form-item class="suicidalFlg" label="自杀、自伤或伤害他人倾向">
        <el-radio @change="tcbx()" v-model="ruleForm.suicidalFlg" label="1">是</el-radio>
        <el-radio @change="tcbx()" v-model="ruleForm.suicidalFlg" label="2">否</el-radio>
      </el-form-item>

      <div v-if="pdtcbx">
        <el-form-item label="发生时间">
          <el-date-picker v-model="ruleForm.suicidalDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发生情况">
          <el-input type="textarea" v-model="ruleForm.suicidalDetail" placeholder="请输入发生情况" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
        <el-form-item class="gyshdqk" label="关于伤害的情况">
          <el-checkbox-group :max="3" v-model="ruleForm.damage">
            <el-checkbox label="1" name="type">自杀想法</el-checkbox>
            <el-checkbox label="2" name="type">自杀计划</el-checkbox>
            <el-checkbox label="3" name="type">自杀未遂</el-checkbox>
            <el-checkbox label="4" name="type">自杀实施中</el-checkbox>
            <el-checkbox label="5" name="type">自杀姿态</el-checkbox>
            <el-checkbox label="6" name="type">被动自杀</el-checkbox>
            <el-checkbox label="7" name="type">自伤自残</el-checkbox>
            <el-checkbox label="8" name="type">伤害他人</el-checkbox>
            <el-checkbox label="9" name="type">扩大性自杀</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item class="InjuryDetails" label="（务必详细描述时间、情况、进展等）">
          <el-input type="textarea" v-model="ruleForm.damageDetail" placeholder="请输入时间、情况、进展等况" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
      </div>

      <h2 style="font-size: 20px;margin-left:20px;padding-bottom:20px">
        重性精神障碍评估（建议参考医生诊断结果）
      </h2>
      <el-form-item class="psychosesFlg" label="疑似重性精神障碍">
        <el-radio @change="tcbx()" v-model="ruleForm.psychosesFlg" label="1">是</el-radio>
        <el-radio @change="tcbx()" v-model="ruleForm.psychosesFlg" label="2">否</el-radio>
      </el-form-item>
      <div v-if="pdtcbx2">
        <el-form-item label="发生时间">
          <el-date-picker v-model="ruleForm.psychosesDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="发生情况">
          <el-input type="textarea" v-model="ruleForm.psychosesDetail" placeholder="请输入发生情况" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item class="yscx" label="疑似出现">
          <el-checkbox-group :max="3" v-model="ruleForm.suspectedAppear">
            <el-checkbox label="1"  name="type">感知觉障碍</el-checkbox>
            <el-checkbox label="2"  name="type">思维障碍</el-checkbox>
            <el-checkbox label="3"  name="type">注意障碍</el-checkbox>
            <el-checkbox label="4"  name="type">记忆障碍</el-checkbox>
            <el-checkbox label="5"  name="type">定向力障碍</el-checkbox>
            <el-checkbox label="6"  name="type">情感障碍</el-checkbox>
            <el-checkbox label="7"  name="type">意志障碍</el-checkbox>
            <el-checkbox label="8"  name="type">动作与行为障碍</el-checkbox>
            <el-checkbox label="9"  name="type">意识障碍</el-checkbox>
            <el-checkbox label="10" name="type">自知力缺失</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <h2 style="font-size:20px;margin-left:20px;padding-bottom:20px;">
        与该生谈话情况/直接接触情况/深度情况/以往了解情况日期
      </h2>

      <el-form-item label="时间">
        <el-date-picker v-model="ruleForm.appearDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="地点">
        <el-input v-model="ruleForm.appearAddress" placeholder="请输入地点" maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="主要内容">
        <el-input type="textarea" v-model="ruleForm.appearDetail" placeholder="请输入主要内容"  maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">
        上报领导
      </h2>

      <el-form-item label="上报领导">
        <el-radio v-model="ruleForm.reportLeaderFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.reportLeaderFlg" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="详情">
        <el-input type="textarea" v-model="ruleForm.reportLeaderDetail" placeholder="请输入详情" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        与家长沟通
      </h2>
      <el-form-item label="家长沟通">
        <el-radio v-model="ruleForm.parentFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.parentFlg" label="2">否</el-radio>
      </el-form-item>
      <el-form-item label="详情">
        <el-input type="textarea" v-model="ruleForm.parentDetail" placeholder="请输入详情" maxlength="1000" show-word-limit></el-input>
      </el-form-item>

      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        就医情况
      </h2>

      <el-form-item label="就医情况">
        <el-radio v-model="ruleForm.hospitalFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.hospitalFlg" label="2">否</el-radio>
      </el-form-item>
      <el-form-item label="医院">
        <el-input v-model="ruleForm.hospitalName" placeholder="请输入医院" maxlength="30" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="诊断结果">
        <el-input type="textarea" v-model="ruleForm.hospitalDetail" placeholder="请输入诊断结果" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        服药情况
      </h2>
      <el-form-item label="服药情况">
        <el-radio v-model="ruleForm.medicineFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.medicineFlg" label="2">否</el-radio>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px; padding-bottom: 20px">
        是否在心理中心咨询
      </h2>
      <el-form-item class="p1" label="是否在心理中心咨询">
        <el-radio @change="tcbx()" v-model="ruleForm.counsultFlg" label="1">是</el-radio>
        <el-radio @change="tcbx()" v-model="ruleForm.counsultFlg" label="2">否</el-radio>
      </el-form-item>
      <div v-if="pdtcbx9">
        <el-form-item class="p2" label="咨询开始时间">
          <el-date-picker v-model="ruleForm.counsultBegin" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="咨询次数">
          <el-input type="number" v-model="ruleForm.counsultTimes" placeholder="请输入咨询次数"></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item class="p3" label="推荐去心理中心">
          <el-radio v-model="ruleForm.recommendCounsultFlg" label="1">是</el-radio>
          <el-radio v-model="ruleForm.recommendCounsultFlg" label="2">否</el-radio>
        </el-form-item>
        <el-form-item class="p4" label="后续实际是否去了">
          <el-radio v-model="ruleForm.realityCounsultFlg" label="1">是</el-radio>
          <el-radio v-model="ruleForm.realityCounsultFlg" label="2">否</el-radio>
        </el-form-item>
      </div>
      <el-form-item class="p5" label="心理联络员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.contactWorkDetail" placeholder="请输入心理联络员配合工作情况" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <el-form-item class="p6" label="心理委员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.committWorkDetail" placeholder="请输入心理委员配合工作情况" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <h2 style="font-size: 20px; margin-left: 20px; padding-bottom: 20px">
        与其他部门协作
      </h2>
      <el-form-item class="p7" label="与（部门）老师联系">
        <el-input v-model="ruleForm.contactDeptName" placeholder="部门名称和老师名称" maxlength="30" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="为该生" class="wgs">
        <el-input type="textarea" v-model="ruleForm.otherTeacherDetail" placeholder="请在此填写其他部门的哪位老师具体参与了哪些学生心理支持工作!" maxlength="1000" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="多方会谈">
        <el-radio v-model="ruleForm.multiPartyFlg" label="1">需要</el-radio>
        <el-radio v-model="ruleForm.multiPartyFlg" label="2">不需要</el-radio>
      </el-form-item>
      <el-form-item class="bgfbf" label="心理中心建议" prop="psychCentralSuggest">
        <el-checkbox-group :max="3" v-model="ruleForm.psychCentralSuggest">
          <el-checkbox label="1"  name="type">精神专科就医</el-checkbox>
          <el-checkbox label="2"  name="type">心理咨询</el-checkbox>
          <el-checkbox label="3"  name="type">心理危机干预</el-checkbox>
          <el-checkbox label="4"  name="type">保密突破联系监护人</el-checkbox>
          <el-checkbox label="5"  name="type">报警急救</el-checkbox>
          <el-checkbox label="6"  name="type">严密守护</el-checkbox>
          <el-checkbox label="7"  name="type">密切陪护</el-checkbox>
          <el-checkbox label="8"  name="type">重点关注</el-checkbox>
          <el-checkbox label="9"  name="type">适当关注</el-checkbox>
          <el-checkbox label="10" name="type">绿色预警交流</el-checkbox>
          <el-checkbox label="11" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userIdlist:[],
      pdtcbx: true,
      pdtcbx2: true,
      pdtcbx9: true, //是否在心理中心咨询
      radio: "1",
      ruleForm: {
        lifeDifficultyOther: "",
        studyDifficultyOther: "",
        contactDifficultyOther: "",
        developDifficultyOther: "",
        psyDifficultyOther: "",
        keyNo: "",
        difficultDetail: "", //严重心理困扰表现
        alertName: "", //预警人
        alertPhone: "", //预警人电话
        userId: "", //学生学号
        realName: "", //学生姓名
        studyDifficulty: [], //学生困难
        lifeDifficulty: [], //生活困难
        contactDifficulty: [], //交往困难
        developDifficulty: [], //发展困难
        psyDifficulty: [], //心理困难
        discovery: [], //发展途径
        firstCrisis: "1", //初评危机状态
        suicidalFlg: "1", //伤害倾向
        suicidalDate: "", //伤害倾向发生时间
        suicidalDetail: "", //发生情况
        damage: [], //伤害发生情况
        damageDetail: "",    //（务必详细描述时间、情况、进展等）
        psychosesFlg: "1",   //重性精神病
        psychosesDate: "",   //重性精神病发生时间
        psychosesDetail: "", //重性精神病发生情况
        suspectedAppear: [], //重性精神病疑似出现
        appearDate: "", //心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况日期
        appearAddress: "", //心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况地点
        appearDetail: "", //心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况详情
        reportLeaderFlg: "1", //上报领导情况 -->1.是 2.否
        reportLeaderDetail: "", //上报领导详情
        parentFlg: "1", //与家长沟通情况 -->1.是 2.否
        parentDetail: "", //与家长沟通详情
        hospitalFlg: "1", //就医情况 -->1.是 2.否
        hospitalName: "", //医院名称
        hospitalDetail: "", //就医详情
        medicineFlg: "1", //服药情况
        recommendCounsultFlg: "", //是否推荐咨询-->1.是 2.否
        realityCounsultFlg: "", //实际是否参与咨询
        contactWorkDetail: "", //心理联络员配合工作情况
        counsultFlg: "1", //是否在心理中心咨询,
        counsultBegin: "", //咨询开始时间
        counsultTimes: "", //咨询次数
        recommendCounsultFlg: "1", //是否推荐咨询-->1.是 2.否
        realityCounsultFlg: "1", //实际是否参与咨询
        contactWorkDetail: "", //心理联络员配合工作情况
        committWorkDetail: "", //心理委员配合工作情况
        contactDeptName: "", //对接其他部门名称
        otherTeacherDetail: "", //通过其他部门老师了解情况
        multiPartyFlg: "1", //多方会商是否需要 -->1.需要 2.不需要
        psychCentralSuggest: [], //心理中心建议
        type:2,
      },
      rules: {
        userId: [{ required: true, message: "请输入学生学号", trigger: "blur" }],
        realName: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
        psychCentralSuggest: [{type: "array",required: true,message: "请至少选择一个心理中心建议",trigger: "change",}],
        alertName: [{ required: true, message: "请输入预警者姓名", trigger: "change" }],
        alertPhone: [{ required: true, message: "请输入预警者电话", trigger: "change" }],
        difficultDetail: [{required: true,message: "请输入学生疑似异常情况",trigger: "change"}],
      },
    };
  },
  methods: {
    xs() {
      for (let i = 0; i < this.userIdlist.length; i++) {
        if (this.ruleForm.userId == this.userIdlist[i].userId) {
          this.ruleForm.realName  = this.userIdlist[i].realName;
          this.ruleForm.deptId    = this.userIdlist[i].deptName;
          this.ruleForm.userIds   = this.userIdlist[i].userId;
          this.ruleForm.userId    = this.userIdlist[i].userId;
          this.ruleForm.trainName = this.userIdlist[i].trainName;
        }
      }
    },
    tcbx() {
      if (this.ruleForm.suicidalFlg == 1) {
        this.pdtcbx = true;
      } else {
        this.pdtcbx = false;
      }
      if (this.ruleForm.psychosesFlg == 1) {
        this.pdtcbx2 = true;
      } else {
        this.pdtcbx2 = false;
      }
      if (this.ruleForm.counsultFlg == 1) {
        this.pdtcbx9 = true;
      } else {
        this.pdtcbx9 = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post("/DistressPrediction/MakeCrisisParameter", {form: this.ruleForm}).then((res) => {
            if (res.Code == 200 || (res.Code == 0 && res.Data)){
              this.Global.request_successful(res.Message);
              this.$router.push({ path: "/Crisis/Crisis_upreport"});
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    this.$Http_Post("/DistressPrediction/DropDownBox", {roleID: sessionStorage.getItem("RoleID")}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.userIdlist = res.Data;
      }
    });
  },
};
</script>
<style>
  .Daily_New_account .jojsss .el-form-item__label {width: 145px !important;}
  .Daily_New_account .cpwjzt .el-form-item__label {width: 125px !important;}
  .Daily_New_account .wgs .el-form-item__label {width: 90px !important;}
  .Daily_New_account .gyshdqk .el-form-item__label {width: 142px !important;}
  .Daily_New_account .yscx .el-form-item__label {width: 100px !important;}
  .Daily_New_account {width: 100%;background-color: rgb(255, 255, 255);overflow: auto;}
  .Daily_New_account .el-input {width: 300px;}
  .Daily_New_account .quz .el-form-item__content {margin-left: 30px !important;}
  .Daily_New_account .bgfbf .el-form-item__label {width: 140px !important;}
  .Daily_New_account .hjoi .el-form-item__label {width: 180px !important;}
  .Daily_New_account .bgssfbf .el-form-item__label {width: 492px !important;}
  .Daily_New_account .huhxs .el-form-item__label {width: 172px !important;}
  .Daily_New_account .huhxsxs .el-form-item__label {width: 160px !important;}
  .Daily_New_account .aaa1 .el-form-item__label {width: 206px !important;}
  .Daily_New_account .aaa2 .el-form-item__label {width: 206px !important;}
  .Daily_New_account .aaa1 .el-form-item__content {margin-left: 210px !important;}
  .Daily_New_account .aaa2 .el-form-item__content {margin-left: 210px !important;}
  .Daily_New_account .suicidalFlg   .el-form-item__label {width: 210px !important;}
  .Daily_New_account .psychosesFlg  .el-form-item__label {width: 160px !important;}
  .Daily_New_account .InjuryDetails .el-form-item__label {width: 275px !important;}
  .Daily_New_account .p1 .el-form-item__label {width: 170px !important;}
  .Daily_New_account .p2 .el-form-item__label {width: 130px !important;}
  .Daily_New_account .p3 .el-form-item__label {width: 142px !important;}
  .Daily_New_account .p4 .el-form-item__label {width: 156px !important;}
  .Daily_New_account .p5 .el-form-item__label {width: 200px !important;}
  .Daily_New_account .p6 .el-form-item__label {width: 186px !important;}
  .Daily_New_account .p7 .el-form-item__label {width: 176px !important;}
  .Daily_New_account .difficulty {width: 1400px !important;}
  .Daily_New_account .el-textarea{width: 50%;}
</style>
<style scoped>
  .el-select-dropdown .el-scrollbar .el-select-dropdown__item{height: 70px;}
</style>